<template>
  <div class="order-container">
    <div class="goods-list-container">
      <div class="confirm-order">
        <div class="img">
          <img src="../../assets/pc/images/pay/order.png" alt="" />
        </div>
        <div class="step">
          <StepNumber align="right" :current="1" chooseType="confirm">
            <StepCommit :index="1">1.我的购物车</StepCommit>
            <StepCommit :index="2">2.填写核对订单信息</StepCommit>
            <StepCommit :index="3">3.成功提交订单</StepCommit>
          </StepNumber>
        </div>
      </div>
      <div class="main-content">
        <div class="main-title">填写并核对订单信息</div>
        <div class="address-form common-padding">
          <div class="title-box common-title">
            <div class="common-red-quote">
              {{ isPrescription ? "提货地址" : "收货地址" }}
            </div>
          </div>
          <div class="address-list">
            <template v-if="border === 0 && !isPrescription">
              <div class="item-list" :class="hideMore ? 'more' : ''">
                <div
                  class="item"
                  v-for="(item, index) of address"
                  :key="item.id"
                  :class="isDefault === item.id ? 'active' : ''"
                  @click="changeAddress(item.id)"
                  @mouseenter="hideEdit = item.id"
                  @mouseleave="hideEdit = ''"
                >
                  <div class="main-name">
                    <strong>{{ item.real_name }}</strong>
                    （收）
                    <div class="edit" v-if="hideEdit === item.id">
                      <span @click="edit(index)">编辑</span>
                      <span>|</span>
                      <span @click="del(index)">删除</span>
                    </div>
                  </div>
                  <div class="main-location">
                    <div class="province">
                      <span v-if="item.is_default === 1" class="default"
                        >[默认地址]</span
                      >
                      {{ item.province }} {{ item.city }} {{ item.district }}
                    </div>
                    <div>{{ item.detail }}</div>
                    <div>{{ item.phone }}</div>
                  </div>
                </div>
              </div>
              <div class="show-more" @click="hideMore = !hideMore">
                <span v-if="hideMore">展开全部地址</span
                ><span v-else>收缩地址</span>
              </div>
              <div class="add-new-address" @click="goAddAddress">
                使用新地址
              </div>
            </template>
            <template v-else>
              <div
                class="item"
                v-for="store of storeList"
                :key="store.id"
                :class="activeStore === store.id ? 'active' : ''"
                @click="changeSelfAddress(store.id)"
              >
                <div class="main-name">
                  <strong>{{ store.name }}</strong>
                </div>
                <div class="main-location">
                  <div>{{ store.address }}</div>
                  <div>{{ store.detailed_address }}</div>
                  <div>{{ store.phone }}</div>
                </div>
              </div>
            </template>
            <div
              v-if="address.length === 0 && !isPrescription"
              class="add-address"
            >
              您还未添加收货地址，前去<span @click="goAddAddress"
                >添加收货地址</span
              >
            </div>
          </div>
        </div>
        <div class="address-choose common-padding" id="address-choose">
          <div class="common-title">
            <div class="common-red-quote transport">
              取货方式
              <div v-if="border === 0 && orderGroupInfo.priceGroup">
                <span>配送费用:</span>
                <span
                  class="red-transport"
                  v-if="orderGroupInfo.priceGroup.storePostage > 0"
                  >￥{{ orderGroupInfo.priceGroup.storePostage }}</span
                >
                <span v-else>免运费</span>
              </div>
            </div>
          </div>
          <div class="transport-type">
            <template v-if="!isPrescription">
              <div @click="radioChange(0)" :class="border === 0 ? 'on' : ''">
                快递配送
              </div>
              <div @click="radioChange(1)" :class="border === 1 ? 'on' : ''">
                到店自提
              </div>
            </template>
            <template v-else>
              <div @click="radioChange(1)" :class="border === 1 ? 'on' : ''">
                到店自提
              </div>
            </template>
          </div>
          <div class="contact-people" v-if="border === 1">
            <div>
              <div class="title">
                <img src="../../assets/pc/images/pay/contact.png" alt="" />
              </div>
              <input
                v-model="contacts"
                type="text"
                class="real-name"
                placeholder="请填写您的联系姓名"
              />
            </div>
            <div>
              <div class="title">
                <img src="../../assets/pc/images/pay/contact-tel.png" alt="" />
              </div>
              <input
                v-model="contactsTel"
                type="text"
                class="real-name"
                placeholder="请填写您的联系电话"
              />
            </div>
          </div>
        </div>
        <div class="product-list common-padding">
          <div class="common-title">
            <div class="common-red-quote">
              商品信息<span
                class="back-cart"
                @click="goBackCart"
                v-if="!isPrescription"
                >[返回购物车]</span
              >
            </div>
          </div>
          <div class="product-box">
            <div class="item-box">
              <div class="item-title item-common">
                <div class="img">产品</div>
                <div class="name">商品名称</div>
                <div class="guige">规格</div>
                <div class="num">需求数量</div>
                <!--<div class="price">小计</div>-->
              </div>
              <div
                class="item item-common"
                v-for="item of shoppingCart"
                :key="item.id"
              >
                <div class="img">
                  <img :src="item.productInfo.image" alt="" />
                </div>
                <div class="name">
                  <router-link
                    tag="span"
                    :to="'/goodsDetail/' + item.product_id"
                    >{{ item.productInfo.store_name }}</router-link
                  >
                </div>
                <div class="guige">
                  {{
                    item.productInfo.attrInfo && item.productInfo.attrInfo.suk
                  }}
                </div>
                <div class="num">{{ item.cart_num }}</div>
                <!--<div class="price">￥{{ item.truePrice }}</div>-->
              </div>
            </div>
            <div class="tip-box">
              <div class="title">添加订单备注</div>
              <input
                v-model="remarks"
                type="text"
                class="remark-input"
                placeholder="在这里填入备注信息"
              />
            </div>
          </div>
        </div>
        <div class="drug-box common-padding" v-if="isPrescription">
          <div class="common-title">
            <div class="common-red-quote">
              上传病例及处方(共2张)
            </div>
          </div>
          <div class="phofo">
            <UploadPic @getPrescriptionImg="getPrescriptionImg"></UploadPic>
          </div>
        </div>

        <div class="pay-container">
          <div class="pay-box">
            <!--
            <p class="allMonkey">
              <span>订单应付总额：</span>
              <span class="money"
                >￥
                <span class="price-font">{{
                  totalPrice.toFixed(2)
                }}</span></span
              >
            </p>
            -->
            <div class="pay-list" v-if="!isPrescription">
              <div
                class="item"
                :class="payType === 'weixin' ? 'active' : ''"
                @click="changePayType('weixin')"
              >
                <div class="left">
                  <img src="../../assets/pc/images/pay/weixin.png" alt="" />
                  微信支付
                </div>
                <div class="right">微信快捷支付</div>
              </div>
              <!-- <div class="item" :class="payType === 'alipay' ? 'active' : ''" @click="changePayType('alipay')">
                <div class="left">
                  <img src="/assets/pc/images/pay/alipay.png" alt="">
                  支付宝支付
                </div>
                <div class="right">支付宝快捷支付</div>
              </div> -->
              <div
                class="item"
                :class="payType === 'yue' ? 'active' : ''"
                @click="changePayType('yue')"
              >
                <div class="left">
                  <img src="../../assets/pc/images/pay/pay.png" alt="" />
                  余额支付
                </div>
                <div class="right">可用余额: {{ userInfo.now_money }}</div>
              </div>
              <div
                class="item"
                :class="payType === 'offline' ? 'active' : ''"
                @click="changePayType('offline')"
                v-if="isOpenOffline"
              >
                <div class="left">
                  <img src="../../assets/pc/images/pay/offline.png" alt="" />
                  线下支付
                </div>
                <div class="right">线下方便支付</div>
              </div>
            </div>
            <div class="pay-btn" @click="commitOrder">
              <Button
                type="error"
                size="large"
                v-if="!isPrescription"
                class="bg-btn"
              >
                支付订单
              </Button>
              <Button type="error" size="large" class="bg-btn" v-else>
                提交审核
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal v-model="modal" width="600">
      <p slot="header">
        <Icon type="add"></Icon>
        <span>{{ addressTitle }}收货地址</span>
      </p>
      <div>
        <Form
          :model="formData"
          label-position="left"
          :label-width="100"
          :rules="ruleInline"
          ref="formDynamic"
        >
          <FormItem label="收件人" prop="real_name">
            <i-input v-model="formData.real_name" size="large"></i-input>
          </FormItem>
          <FormItem label="收件地区" prop="address">
            <div @click.stop="show2 = true">
              <i-input v-model="modelAdress" size="large"></i-input>
            </div>
            <CitySelect
              v-model="show2"
              :callback="result2"
              :items="district"
              provance=""
              city=""
              area=""
            ></CitySelect>
          </FormItem>
          <FormItem label="详细地址" prop="detail">
            <i-input v-model="formData.detail" size="large"></i-input>
          </FormItem>
          <FormItem label="手机号码" prop="phone">
            <i-input v-model="formData.phone" size="large"></i-input>
          </FormItem>
        </Form>
      </div>
      <div class="setAddress">
        <div class="title">
          设置为默认地址
        </div>
        <i-switch v-model="switch1" @on-change="changeSwitch" />
      </div>
      <div slot="footer">
        <Button @click="modal = false">取消</Button>
        <Button type="primary" @click="editAction">提交</Button>
      </div>
    </Modal>
    <div class="mask" v-if="maskShow">
      <div class="content">
        <div class="title" v-if="payType === 'weixin' || payType === 'alipay'">
          <img src="../../assets/pc/images/pay/success.png" alt="" />
          <span class="success">付款二维码生成中</span>
        </div>
        <div class="title" v-else>
          <img
            src="../../assets/pc/images/pay/loading.png"
            alt=""
            class="laoding"
          />
          <span class="success">订单处理中</span>
        </div>
        <div class="time">请稍等...</div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadPic from "@/components/pc/commonTool/UploadPic";
import StepNumber from "@/components/pc/commonTool/Steps/StepNumber";
import StepCommit from "@/components/pc/commonTool/Steps/StepCommit";
import {
  getAddressList,
  getUserInfo,
  postAddress,
  getAddressRemove
} from "@api/user";
import { postOrderConfirm, createOrder, postOrderComputed } from "@api/order";
import { storeListApi } from "@api/store";
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import District from "ydui-district/dist/jd_province_city_area_id";
export default {
  name: "Order",
  components: {
    CitySelect,
    UploadPic,
    StepNumber,
    StepCommit
  },
  data() {
    return {
      goodsCheckList: [],
      checkAddress: {
        name: "未选择",
        address: "请选择地址"
      },
      remarks: "",
      shoppingCart: [], // 渲染所需的格式
      border: 0, // 0为快递配送
      system_store: {}, // 自提地址
      address: [],
      isDefault: 1, // 默认地址, 提交参数所需的地址ID
      pinkId: 0, // 拼团ID
      userInfo: {},
      payType: "yue",
      orderGroupInfo: {},
      totalPrice: 0,
      contacts: "",
      contactsTel: "",
      activeStore: "",
      modal: false,
      formData: {
        real_name: "",
        address: {
          province: "",
          city: "",
          city_id: "",
          district: ""
        },
        phone: "",
        post_code: "",
        is_default: 0,
        detail: "",
        id: ""
      },
      ruleInline: {
        real_name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        detail: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          {
            type: "string",
            pattern: /^1[3|4|5|7|8][0-9]{9}$/,
            message: "手机号格式出错",
            trigger: "blur"
          }
        ]
      },
      show2: false,
      modelAdress: "选择收货地区",
      district: District,
      switch1: false,
      imageList: [], // 处方图片
      maskShow: false,
      storeList: [],
      recodeScrollWidth: "",
      hideMore: true, // 是否展示更多地址信息
      hideEdit: "",
      addressTitle: "新增",
      isPrescription: true, // 判断是否是处方药
      isOpenOffline: false
    };
  },
  async created() {
    getUserInfo().then(res => {
      this.userInfo = res.data;
    });

    const cartId = this.$route.params.cardId;
    let res = await postOrderConfirm(cartId);

    this.system_store = res.data.system_store;
    this.orderGroupInfo = res.data;

    // 根据处方展示地址
    res.data.cartInfo.forEach(item => {
      this.isPrescription =
        item.productInfo.is_prescription === 1 ? true : false;
    });
    if (this.isPrescription) {
      this.border = 1;
    }

    this.shoppingCart = res.data.cartInfo;
    this.computedPrice();

    if (this.$route.query.pinkid !== undefined) {
      // 获取拼团id
      this.pinkId = this.$route.query.pinkid;
    }

    this.isOpenOffline = res.data.offline_pay_status === 1 ? true : false;
  },
  mounted() {
    this.getAddressInfo(); // 渲染收货地址
    this.getStoreListApi(); // 渲染自提地址
  },
  methods: {
    radioChange(index) {
      this.border = index;
      this.computedPrice();
    },
    changeSelfAddress(index) {
      this.activeStore = index;
    },
    async getAddressInfo() {
      // 获取收货地址
      const res = await getAddressList();
      this.address = res.data;
      let notDefault = true; // 没有默认地址
      this.address.forEach(item => {
        if (item.is_default === 1) {
          notDefault = false;
          this.isDefault = item.id;
          this.changeAddress(item.id);
        }
      });
      // 没有默认地址，选第一个做为默认地址
      if (!notDefault && this.address.length > 0) {
        this.changeAddress(this.address[0].id);
      }
    },
    async getStoreListApi() {
      // 自提地址
      const res = await storeListApi();
      this.storeList = res.data.list;
      if (res.data.list.length > 0) {
        this.activeStore = res.data.list[0].id;
      }
    },
    changeAddress(data) {
      // 更改收货地址
      this.isDefault = data;
      this.address.forEach(item => {
        if (item.id === data) {
          this.checkAddress.name = item.real_name;
          this.checkAddress.address = `${item.real_name} ${item.phone} ${
            item.province
          } ${item.city} ${item.district} ${item.detail}  ${
            item.is_default === 1 ? "[默认]" : ""
          }`;
        }
      });
    },
    changePayType(type) {
      // 更改付款方式
      this.payType = type;
    },
    computedPrice() {
      // 实时更新总价
      postOrderComputed(this.orderGroupInfo.orderKey, {
        addressId: this.isDefault,
        useIntegral: 0,
        couponId: 0,
        shipping_type: this.border + 1
      }).then(res => {
        this.totalPrice = res.data.result.pay_price;
      });
    },
    commitOrder() {
      // 提交订单
      if (this.imageList.length < 2 && this.isPrescription) {
        this.$Message.error("上传处方药和病历图片(共2张)");
        return;
      }

      // 如果是自提情况
      if (this.border === 1) {
        if (this.contacts === "" || this.contactsTel === "") {
          this.$Message.error("请填写联系人或联系人电话");
          document.getElementById("address-choose").scrollIntoView();
          return;
        }

        if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.contactsTel)) {
          document.getElementById("address-choose").scrollIntoView();
          return this.$Message.error("请填写联系人电话");
        }
        if (!/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.contacts)) {
          document.getElementById("address-choose").scrollIntoView();
          return this.$Message.error("请填写您的真实姓名");
        }
      }

      const params = {
        real_name: this.contacts,
        phone: this.contactsTel,
        pinkId: this.pinkId,
        addressId: this.isDefault,
        payType: this.payType,
        productPriceList: [], // 暂时先不传信息
        mark: this.remarks,
        store_id: this.activeStore,
        shipping_type: this.border + 1, // 参数为配送的类型
        from: this.payType === "weixin" ? "weixinpc" : "weixinh5",
        certification_type: this.userInfo.certification_type,
        prescription: this.imageList
      };

      this.maskShow = true;
      createOrder(this.orderGroupInfo.orderKey, params)
        .then(res => {
          const OrderInfo = res.data;
          if (OrderInfo.status === "SUCCESS") {
            this.$router.replace({
              path: "/home/myOrder"
            });
          } else if (OrderInfo.status === "WECHAT_PC_PAY") {
            const img = res.data.result.results.codeUrl;
            const orderId = res.data.result.results.order_id;
            this.$router.push({
              name: "Pay",
              params: { img, orderId }
            });
          } else if (OrderInfo.status === "PAY_DEFICIENCY") {
            // this.$Message.error(res.msg);
            this.$Modal.error({
              title: "温馨提示",
              content: res.msg,
              onOk: () => {
                this.$router.go(-1);
              }
            });
          }
          this.maskShow = false;
        })
        .catch(err => {
          console.log(err);
          // this.$Message.error(err.msg);
        });
    },
    goAddAddress() {
      // 打开隐藏新增收货地址的面板
      this.addressTitle = "新增";
      this.modal = true;
      // 重置以前留下的数据
      this.formData.address.province = "";
      this.formData.address.city = "";
      this.formData.address.city_id = "";
      this.formData.address.district = "";
      this.formData.id = "";
    },
    editAction() {
      if (this.addressTitle === "新增") {
        // 提交新增收货地址
        this.$refs.formDynamic.validate(valid => {
          if (valid) {
            postAddress(this.formData).then(res => {
              if (res.status === 200) {
                this.$Message.success("添加成功");
                this.modal = false;
                this.getAddressInfo();
              }
            });
          }
        });
      } else {
        postAddress(this.formData).then(res => {
          if (res.status === 200) {
            this.$Message.success("修改成功");
            this.modal = false;
            this.getAddressInfo();
          }
        });
      }
    },
    result2(ret) {
      // 省市区选择
      this.modelAdress =
        ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
      this.formData.address.province = ret.itemName1;
      this.formData.address.city = ret.itemName2;
      this.formData.address.city_id = ret.itemValue2;
      this.formData.address.district = ret.itemName3;
    },
    changeSwitch(status) {
      // 是否设置为默认地址
      if (status) {
        this.formData.is_default = 1;
      } else {
        this.formData.is_default = 0;
      }
    },
    getPrescriptionImg(list) {
      // 获取子组件传来的处方图片
      this.imageList = list;
    },
    goBackCart() {
      this.$router.push({
        path: "/shoppingCart"
      });
    },
    edit(index) {
      this.addressTitle = "编辑";
      this.modal = true;
      this.formData.address = {
        province: this.address[index].province,
        city: this.address[index].city,
        district: this.address[index].district
      };
      this.formData.real_name = this.address[index].real_name;
      this.formData.detail = this.address[index].detail;
      this.formData.phone = this.address[index].phone;
      this.formData.id = this.address[index].id;
      this.modelAdress =
        this.address[index].province +
        " " +
        this.address[index].city +
        " " +
        this.address[index].district;
    },
    del(index) {
      this.$Modal.confirm({
        title: "信息提醒",
        content: "你确定删除这个收货地址",
        onOk: () => {
          getAddressRemove(this.address[index].id).then(res => {
            if (res.status === 200) {
              this.$Message.success("删除成功");
              this.getAddressInfo();
            }
          });
        },
        onCancel: () => {
          this.$Message.info("取消删除");
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
/deep/ .yd-cityselect-title
  font-size 14px

.order-container
  background #fff
  padding-top 40px
  .goods-list-container
    width 990px
    margin 0 auto
    .confirm-order
      margin-bottom 30px
      display flex
      justify-content space-between
      .img
        width 190px
        height 35px
        img
          width 100%
          height 100%
    .main-title
      background #f2f2f2
      height 45px
      line-height 45px
      font-size 16px
      font-family 'Microsoft yahei'
      text-indent 18px
      color #555
    .address-form
      padding-bottom 20px
      .address-list
        .item-list
          &.more
            height 140px
            overflow hidden

        .item
          width 212px
          min-height 80px
          border 1px solid #eaeaea
          padding 0 8px
          cursor pointer
          display inline-block
          margin-right 20px
          margin-bottom 20px
          &.active
            border 2px solid #377bee
            position relative
            &::after
              content: ''
              display inline-block
              width 30px
              height 30px
              background-image url('../../assets/pc/images/pay/active.jpg')
              background-size 100% 100%
              position absolute
              right 0
              bottom 0
          .main-name
            height 30px
            line-height 30px
            border-bottom 1px dotted #e4e4e4
            color #000
            padding-right 80px
            font-family 'Arial'
            position relative
            .edit
              position absolute
              top 0
              right 0
              display flex
              width 70px
              justify-content space-between
              align-items center
              color #999
          .main-location
            padding 14px 0
            font-family Arial
            line-height 20px
            color #666
            .province
              .default
                color #377bee
        .show-more
          font-family Arial
          cursor pointer
          color #377bee
        &.self-list
          justify-content flex-start
        .add-address
          text-align center
          line-height 80px
          font-size 16px
          color #888
          span
            color #377bee
            cursor pointer
      .add-new-address
        width 82px
        height 25px
        line-height 25px
        font-weight bold
        text-align center
        margin 10px auto 20px 0px
        color #000
        cursor pointer
        border 1px solid #ddd
        font-family '宋体'
        background: linear-gradient(#fff, #ddd)
    .address-choose
      .transport
        div
          color #999
          font-size 14px
          display inline-block
          margin-left 30px
          span:last-child
            margin-left 10px
          .red-transport
            color #377bee
            font-weight 700
      .transport-type
        display flex
        margin-bottom 16px
        div
          height 38px
          width 120px
          text-align center
          line-height 38px
          border 1px solid #e6e6e6
          margin-right 13px
          font-size 14px
          cursor pointer
          &.on
            border 1px solid #377bee
            position relative
            &::after
              content: ''
              display inline-block
              width 20px
              height 20px
              background-image url('../../assets/pc/images/pay/active.jpg')
              background-size 100% 100%
              position absolute
              right 0
              bottom 0
      .contact-people
        >div
          display flex
          margin-bottom 10px
          .title
            width 25px
            height 25px
            margin-right 20px
            transform translateY(3px)
            img
              width 100%
              height 100%
          .real-name
            border 1px solid #f1f1f1
            border-radius 4px
            line-height 30px
            background #fafafa
            padding-left 5px
            &::-webkit-input-placeholder
              color #bbb
            &:-moz-placeholder
              color #bbb
            &:moz-placeholder
              color #bbb
            &:-ms-input-placeholder
              color #bbb
    .product-list
      .back-cart
        color #377bee
        cursor pointer
        margin-left 10px
        font-family Arial
        font-size 12px
      .product-box
        .item-box
          .item-title
            background #f5f5f5
            border 1px solid #f0f0f0
            display flex
            line-height 38px
          .item-common
            text-align center
            color #333
            .img
              width 120px
            .name
              width 400px
            .guige
              width 150px
            .num
              width 150px
            .price
              flex 1
          .item
            display flex
            border-bottom 1px solid #dddddd
            padding 10px 0
            align-items center
            font-family Arial
            .img
              img
                width 65px
                height 65px
            .name
              color #377bee
              padding 0 10px
              span
                cursor pointer

      .tip-box
        margin-left 20px
        margin-top 35px
        margin-bottom 20px
        .title
          font-size 14px
          margin-bottom 10px
        .remark-input
          border 1px solid #e3e3e3
          height 30px
          width 480px
          border-radius 3px
          padding-left 10px
    .drug-box
      .phofo
        margin-left 20px
    .pay-container
      margin 15px
      display flex
      justify-content flex-end
      .pay-box
        font-size 18px
        font-weight bolder
        color #495060
        .pay-btn
          margin 15px 0px
          display flex
          justify-content flex-end
          .bg-btn
            font-size 16px
            background #ff4040
            width 100px
      .allMonkey
        text-align right
        .money
          font-size 16px
          color #ff4040
          .price-font
            font-size 30px
            margin-left -6px
      .pay-list
        margin 10px 0
        min-width 280px
        .item
          display flex
          justify-content space-between
          border 1px solid #dedede
          font-size 14px
          font-weight normal
          padding 5px
          margin-bottom 10px
          cursor pointer
          &.active
            border 1px solid #ff7a7a
          .left
          .right
            width 50%
            text-align center
          .left
            border-right 1px solid #eee
            img
              width 18px
              height 18px
              position relative
              top 4px
          .right
            color #9b9b9b

  .common-padding
    padding 20px 20px 10px 40px
    border 1px solid #f0f0f0
    border-top 0
    background #fff
  .common-title
    display flex
    justify-content space-between
    font-size 16px
  .common-red-quote
    color #333
    margin-left 15px
    margin-bottom 25px
    &:before
      content:''
      display inline-block
      width 3px
      height 20px
      background #377bee
      transform translateX(-15px) translateY(4px)

  .mask
    position fixed
    top: 0
    background rgba(0, 0, 0, .5)
    left 0
    right 0
    bottom 0
    display flex
    align-items center
    justify-content center
    z-index 999
    .content
      width 300px
      height 150px
      background #fff
      padding 30px
      border-radius 8px
      .title
        text-align center
        .laoding
          animation:turn 2s linear infinite
        img
          width 24px
          height 24px
          display inline-block
          position relative
          top 6px
        .success
          font-size 18px
          margin-left 5px
    .time
      margin-top 25px
      text-align center
      font-size 14px

  @keyframes turn
    0%
      -webkit-transform rotate(0deg)
    25%
      -webkit-transform rotate(90deg)
    50%
      -webkit-transform rotate(180deg)
    75%
      -webkit-transform rotate(270deg)
    100%
      -webkit-transform rotate(360deg)
</style>
